import { useState } from "react";

export default function ServiceCard(props){
    const [showMore,setShowMore] = useState(false);
    let description;
    if(showMore){
         description = props.descriptions;
    }
    else{
         description = props.descriptions.slice(0,3);
    }
    

    function showFullDescription(){
        if (showMore){
            setShowMore(false);
        }
        else {
            setShowMore(true);
        }
    }
    return (
        <div class="card">
            <div class="img-container">
                <img src={props.image} alt="service"/>
            </div>
            <div class="card-content">
                <h3>{props.title}</h3>
                <ul>
                    {description.map((item) => {
                        return(<li>{item}</li>);
                    })}
                </ul>
                {props.descriptions.length > 3 && <button className="btn" onClick={showFullDescription}>{showMore ? 'show less': 'show more'}</button>}
                
            </div>
        </div>
    );
}